import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { OrderProviderExternalErrorChartData } from 'types/embedded/orderProviderExternalErrors';

export type OrderProviderExternalErrorsChartDataParams = {
  widgets: string[];
  dateFrom: number;
  dateTo: number;
  timezone?: string | null;
  isCritical?: boolean | null;
  rejectReason?: string[] | null;
  merchant?: string[] | null;
  provider?: string[] | null;
  gateway?: string[] | null;
  method?: string[] | null;
  category?: string[] | null;
  direction: string | null;
};

export const getOrderProviderExternalErrorsChartData = async (
  filter: OrderProviderExternalErrorsChartDataParams = {} as OrderProviderExternalErrorsChartDataParams,
): Promise<OrderProviderExternalErrorChartData> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', indices: false, encode: true },
  );
  return axios
    .get(`provider_external_error/chart_data?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
